/** @jsxImportSource theme-ui */
import { Component } from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

import LogApi from 'api/LogApi';

const Styles: ThemeUIStyleObject = {
  width: '100%',
  pt: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  pointerEvents: 'all',
  '& h1': { mb: '12' },
};

type State = { hasError: boolean };

class ErrorBoundary extends Component<{}, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error) {
    LogApi.sendLog('fatal', JSON.stringify(error, Object.getOwnPropertyNames(error)));
  }

  render() {
    return this.state.hasError ? (
      <div sx={Styles}>
        <h1>Something went wrong.</h1>
        <div>
          Please <a href="."> refresh</a> and try again. If you keep seeing this screen please
          contact your Customer Success Representative.
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
